import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaHandsHelping, FaCommentDots, FaHome } from 'react-icons/fa';

const Activities = () => {
  const imageUrls = [
    '/images/DSC_4405.jpg',
    '/images/slider1.jpg',
    '/images/slider2.jpg',
    '/images/slider3.jpg',
    '/images/DSC_2980.jpg',
    '/images/DSC_4392.jpg',
    '/images/DSC_4412.jpg',
    '/images/DSC_4448-2.jpg',
    '/images/DSC_6304.jpg',
    '/images/DSC_4370.jpg',
    '/images/DSC_4340.jpg',
    '/images/DSC_3024.jpg',
    '/images/DSC_2995.jpg',
    '/images/DSC_4584.jpg',
    '/images/DSC_4612.jpg',
    '/images/DSC_4495.jpg',
    '/images/DSC_4454.jpg',
    '/images/DSC_4337.jpg',
    '/images/wa1.jpg',
    '/images/wa2.jpg',
    
    

  ];
  const events = [
    {
      name: 'Sunday Worship Service',
      time: 'Every Sunday, 10 AM',
      location: '97 Hensman Street, South Perth',
      description: 'Join us for a spirit-filled time of worship, word, and fellowship.',
    },
    {
      name: 'Prayer Meeting',
      time: 'Tuesday, 6 PM',
      location: 'Zoom',
      description: 'A quiet evening of intercession and Bible study.',
    },
    {
      name: 'Thrive',
      time: 'Wednesday Fortnitely',
      location: '1 Alpike Road, Darllington',
      description: 'Music, games, and real talk for teens and young adults.',
    },
    {
      name: 'House Fellowship',
      time: 'Saturday, 5 PM',
      location: 'Local neighborhoods',
      description: 'Come expectant for breakthrough and restoration.',
    },
    {
      name: 'Community Outreach',
      time: 'Monthly (varies)',
      location: 'Local neighborhoods',
      description: 'Serving with love—food drives, prayer walks, and care packages.',
    },
    {
      name: 'Mighty Men',
      time: 'Last Sunday',
      location: 'Local neighborhoods',
      description: 'Gathering of men committed to spiritual leadership, personal growth and kigdom impact.',
    },
    {
      name: 'Womens Meeting',
      time: 'First Sunday',
      location: 'Local neighborhoods',
      description: 'A space for women to be refreshed, empowered, and equipped.',
    },
    {
      name: 'New Month Prayer',
      time: 'Every new month',
      location: 'Zoom',
      description: 'As we step into a new month, we gather in faith to seek the presence of God, declare His promises, and align our hearts with his purpose.',
    }
  ];

const involvementOptions = [
  {
    icon: <FaHandsHelping />,
    title: 'Volunteer for an Event',
    link: '/volunteer',
    description: 'Serve with joy and be part of something bigger than yourself.',
  },
  {
    icon: <FaCommentDots />,
    title: 'Share Your Testimony',
    link: '/testimony',
    description: 'Your story can inspire faith and bring hope to others.',
  },
  {
    icon: <FaHome />,
    title: 'Host a Home Fellowship',
    link: '/fellowship',
    description: 'Open your home to community, prayer, and spiritual growth.',
  },
];

  const containerVariants = {
//   hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      staggerChildren: 0.2,
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  React.useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  const specials = [
    'Power of Praise Concert – An evening of uplifting worship with guest artists.',
    'Activate Conference – A weekend of empowerment for believers of all ages.',
    'Christmas Cantata – A musical celebration of Christ’s birth with choir, drama, and candlelight.',
    'Easter Sunrise Service – Gather outdoors to celebrate the resurrection with worship and communion.',

  ];

  return (
    <div className="events-page">
      <motion.h1
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}>Gatherings That Uplift</motion.h1>
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 1 }}>“Our events are more than dates on a calendar. They are sacred moments where hearts connect, faith deepens, and lives are transformed.”
      </motion.p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {events.map((event, index) => (
          <motion.div className='activities'
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            style={{
              background: '#fff',
              padding: '1.5rem',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              fontFamily: 'Georgia, serif',
            }}
          >
            <h3 style={{ textAlign:'center', marginBottom: '0.5rem', color: '#333' }}>{event.name}</h3>
            <p><strong>Time:</strong> {event.time}</p>
            <p><strong>Location:</strong> {event.location}</p>
            <p>{event.description}</p>
          </motion.div>
        ))}
      </div>

      <motion.section
      className="special-events"
      ref={ref}
      variants={containerVariants}
      initial="hidden"
      animate={controls}
    >
      <h2 className="special-title">Special Events</h2>
      <div className="special-list">
        {specials.map((item, index) => (
          <motion.div
            key={index}
            className="special-card"
            variants={itemVariants}
          >
            <FaStar className="special-icon" />
            <p>{item}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>

      <section className="event-hlf">
      <h2>Event Highlights</h2>
      <p>Moments captured, memories cherished.</p>
      <div className="event-hlf-cds">
        {imageUrls.map((url, index) => (
          <motion.div
            key={index}
            className="event-img-card"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.05 }}
            viewport={{ once: true }}
          >
            <img src={url} alt={`Event ${index + 1}`} />
          </motion.div>
        ))}
      </div>
    </section>
    <section className="get-involved-section">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Get Involved
      </motion.h2>
      <div className="involvement-grid">
        {involvementOptions.map((item, index) => (
          <motion.div
            key={index}
            className="involvement-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="involvement-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <Link to={item.link} className="involvement-link">
              Get Started →
            </Link>
          </motion.div>
        ))}
      </div>
    </section>


      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.5 }}
        style={{ textAlign: 'center', marginTop: '3rem', overflow: 'hidden' }}
      >
        <h2>Plan Your Visit</h2>
        <p>New here? We would love to welcome you.</p>
        <Link to="/visit" style={{
          backgroundColor: '#ea9e42ff',
          color: '#091C2D',
          padding: '0.8rem 1.5rem',
          borderRadius: '6px',
          fontSize: '1rem',
          fontWeight: 'bold',
          textDecoration: 'none',
          boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        }}>
          Plan Your Visit
        </Link>
      </motion.div>

      
    </div>
  );
};

export default Activities;
